"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.isFormValueInitial = exports.getPersistedQueryFormFields = exports.validateValue = exports.persistFormFields = exports.getPersistedCookiesFormFields = exports.parsePersistedCookiesFormFields = void 0;
const js_cookie_1 = __importDefault(require("js-cookie"));
const constants_1 = require("../../utils/constants");
const validation_1 = require("../../shared/validation");
const parsePersistedCookiesFormFields = (formName, cookies) => JSON.parse(cookies ? cookies[formName] || '{}' : '{}');
exports.parsePersistedCookiesFormFields = parsePersistedCookiesFormFields;
const getPersistedCookiesFormFields = (formName, cookies, initialValues) => {
    const cookieFormFields = (0, exports.parsePersistedCookiesFormFields)(formName, cookies);
    Object.keys(cookieFormFields).forEach((fieldName) => {
        if (initialValues[fieldName] === undefined) {
            delete cookieFormFields[fieldName];
        }
    });
    return cookieFormFields;
};
exports.getPersistedCookiesFormFields = getPersistedCookiesFormFields;
const persistFormFields = (formName, formValues, { isPartialUpdate } = {}) => {
    const previousFormValues = isPartialUpdate
        ? (0, exports.parsePersistedCookiesFormFields)(formName, js_cookie_1.default.get())
        : undefined;
    const formValuesToUpdate = Object.assign(Object.assign({}, previousFormValues), formValues);
    js_cookie_1.default.set(formName, JSON.stringify(formValuesToUpdate), {
        expires: constants_1.FORM_COOKIE_EXPIRE_TIME,
    });
};
exports.persistFormFields = persistFormFields;
const validateValue = ({ isRequired, isRequiredMessage, validationRules, value, }) => {
    if (isRequired === undefined &&
        isRequiredMessage === undefined &&
        validationRules === undefined) {
        return [];
    }
    const errors = (0, validation_1.validate)(value, isRequired, validationRules, isRequiredMessage);
    return errors;
};
exports.validateValue = validateValue;
const getPersistedQueryFormFields = ({ initialValues, query, fieldsOptions, getQueryValue, }) => Object.keys(initialValues).reduce((acc, currName) => {
    const { isRequired, isRequiredMessage, validationRules } = (fieldsOptions &&
        fieldsOptions[currName]) || {
        isRequired: undefined,
        isRequiredMessage: undefined,
        validationRules: undefined,
    };
    const queryValue = getQueryValue ? getQueryValue(currName, query) : query[currName];
    if (!queryValue) {
        return acc;
    }
    const initialValue = initialValues[currName];
    const convertValue = (value) => {
        const valueType = typeof (Array.isArray(initialValue) ? initialValue[0] : initialValue);
        switch (valueType) {
            case 'boolean':
                return value === 'true';
            case 'number':
                return Number(value);
            default:
                return value;
        }
    };
    // eslint-disable-next-line no-nested-ternary
    const value = Array.isArray(initialValue)
        ? (Array.isArray(queryValue) ? queryValue : [queryValue]).map((val) => convertValue(val))
        : convertValue(queryValue);
    const valueErrors = (0, exports.validateValue)({
        isRequired,
        isRequiredMessage,
        value,
        validationRules,
    });
    acc[currName] = valueErrors.length ? initialValue : value;
    return acc;
}, {});
exports.getPersistedQueryFormFields = getPersistedQueryFormFields;
const isFormValueInitial = (value, initialValue) => {
    if (Array.isArray(initialValue) && Array.isArray(value)) {
        return (initialValue.length === value.length &&
            initialValue.every((val, index) => val === value[index]));
    }
    return value === initialValue;
};
exports.isFormValueInitial = isFormValueInitial;
//# sourceMappingURL=utils.js.map